import { __assign } from "tslib";
import React from 'react';
import { FabricChannel } from '../types';
import processEvent from './process-event';
import GenericAnalyticsListener from '../GenericAnalyticsListener';
export default function NavigationListener(props) {
    return (React.createElement(GenericAnalyticsListener, __assign({}, props, { channel: FabricChannel.navigation, processEvent: processEvent })));
}
//# sourceMappingURL=NavigationListener.js.map